// @file Surface language panel store
import { useSurfaceStore } from '@@/pinia/surface'
import { useCommentsStore } from '@@/pinia/surface_comments'
import { useSurfacePostsStore } from '@@/pinia/surface_posts'
import { useSurfaceSectionsStore } from '@@/pinia/surface_sections'
import { WallTranslationApi } from '@@/surface/api/wall_translation'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSurfaceLanguagePanelStore = defineStore('surfaceLanguagePanelStore', () => {
  const surfaceStore = useSurfaceStore()
  const surfaceSectionsStore = useSurfaceSectionsStore()
  const surfacePostsStore = useSurfacePostsStore()
  const surfaceCommentsStore = useCommentsStore()

  const xSurfaceLanguagePanel = ref<boolean>(false)
  const currentLanguage = ref<string>('en')
  const isTranslatingPadlet = ref<boolean>(false)

  const showLanguagePanel = (): void => {
    xSurfaceLanguagePanel.value = true
  }

  const closeLanguagePanel = (): void => {
    xSurfaceLanguagePanel.value = false
  }

  async function translatePadletToLanguage(selectedLanguage: string): Promise<void> {
    try {
      isTranslatingPadlet.value = true
      currentLanguage.value = selectedLanguage
      const data = await WallTranslationApi.translate(surfaceStore.wallId, selectedLanguage)
      surfaceStore.updateWall({ title: data.title, description: data.description })
      surfaceSectionsStore.updateSectionEntitiesWithTranslatedTitles(data.sections)
      surfacePostsStore.updatePostsWithTranslations(data.wishes)
      surfaceCommentsStore.updateCommentsWithTranslatedBody(data.comments)
    } catch (error) {
      // TODO: ENG-19994 - Handle error state
    } finally {
      isTranslatingPadlet.value = false
      closeLanguagePanel()
    }
  }

  return {
    xSurfaceLanguagePanel,
    currentLanguage,
    isTranslatingPadlet,
    showLanguagePanel,
    closeLanguagePanel,
    translatePadletToLanguage,
  }
})
